import './Paper.css';

type Props = {
    children: React.ReactNode;
    className?: string;
};

// Wrapper for content with white background and rounded corners. Content that is not in this wrapper must have padding set
const Paper = ({ children, className }: Props) => {
    return <div className={`paper ${className || ''}`}>{children}</div>;
};

export default Paper;
